const duoTexts = document.querySelectorAll('[data-animate-bar]');
const activeItems = new Set();
let ticking = false;

// Observe when items enter/leave viewport
const observer = new IntersectionObserver(
	(entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				activeItems.add(entry.target);
			} else {
				activeItems.delete(entry.target);
				// reset when fully out of view
				entry.target.style.setProperty('--borderProgress', 0);
			}
		});
	},
	{
		threshold: 0, // we’ll handle the “50% feel” manually
	}
);

duoTexts.forEach((el) => observer.observe(el));

function updateBorders() {
	const vh = window.innerHeight || document.documentElement.clientHeight;

	activeItems.forEach((el) => {
		const rect = el.getBoundingClientRect();

		// 🎯 Tweak these to change when the bar starts/finishes:
		const start = vh * 0.8; // element top at 80% viewport → start filling
		const end = vh * 0.2;   // element top at 20% viewport → fully filled

		// Map rect.top from [start → end] to [0 → 1]
		let raw = (start - rect.top) / (start - end);
		let progress = Math.max(0, Math.min(1, raw)); // clamp between 0 and 1

		el.style.setProperty('--borderProgress', progress.toFixed(3));
	});

	ticking = false;
}

function onScroll() {
	if (!ticking) {
		ticking = true;
		requestAnimationFrame(updateBorders);
	}
}

window.addEventListener('scroll', onScroll);
window.addEventListener('resize', updateBorders);

// run once on load
updateBorders();